import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div style={{ minHeight: "100vh", background: "#F8F9FA", color: "#1A1A1A" }}>
      <div style={{ maxWidth: 720, margin: "0 auto", padding: "48px 24px 80px" }}>
        <Link to="/" style={{ color: "#0B9FBD", textDecoration: "none", fontSize: 14, display: "inline-block", marginBottom: 24 }}>
          &larr; Back to LiveBetter
        </Link>
        <h1 style={{ fontSize: 32, fontWeight: 700, marginBottom: 8, fontFamily: "Outfit, sans-serif" }}>Terms of Service</h1>
        <p style={{ color: "#666", marginBottom: 40 }}>Last updated: March 29, 2026</p>

        <Section title="1. Acceptance of Terms">
          <p>
            By accessing or using LiveBetter ("the Service"), you agree to be bound by these Terms of
            Service ("Terms"). If you do not agree, do not use the Service.
          </p>
        </Section>

        <Section title="2. Description of Service">
          <p>
            LiveBetter is a preventive health intelligence platform that helps users track daily
            wellness metrics, receive personalized insights, and build healthier habits. The Service
            includes a mobile application and web platform.
          </p>
        </Section>

        <Section title="3. Eligibility">
          <p>
            You must be at least 13 years old to use LiveBetter. If you are under 18, you must have
            parental or guardian consent. By using the Service, you represent that you meet these
            requirements.
          </p>
        </Section>

        <Section title="4. Account Responsibilities">
          <ul style={ulStyle}>
            <li>You are responsible for maintaining the security of your account credentials.</li>
            <li>You must provide accurate and complete information when creating your account.</li>
            <li>You are responsible for all activity that occurs under your account.</li>
            <li>You must notify us immediately of any unauthorized use of your account.</li>
          </ul>
        </Section>

        <Section title="5. Acceptable Use">
          <p>You agree not to:</p>
          <ul style={ulStyle}>
            <li>Use the Service for any unlawful purpose</li>
            <li>Submit false, misleading, or fraudulent information</li>
            <li>Attempt to gain unauthorized access to the Service or its systems</li>
            <li>Interfere with or disrupt the Service or servers</li>
            <li>Reverse-engineer, decompile, or disassemble any part of the Service</li>
            <li>Use automated tools to scrape or collect data from the Service</li>
            <li>Impersonate another person or misrepresent your affiliation</li>
            <li>Harass, abuse, or send unwanted communications to other users</li>
          </ul>
        </Section>

        <Section title="6. Health Disclaimer">
          <p>
            <strong>LiveBetter is not a medical service.</strong> The wellness scores, insights,
            predictions, and recommendations provided by LiveBetter are for general informational and
            educational purposes only. They do not constitute medical advice, diagnosis, or treatment.
          </p>
          <p>
            You should not rely on LiveBetter as a substitute for professional medical advice. Always
            seek the guidance of a qualified healthcare provider with any questions regarding a medical
            condition. Never disregard professional medical advice or delay seeking it because of
            information provided by LiveBetter.
          </p>
          <p>
            If you are experiencing a medical emergency, call your local emergency services
            immediately.
          </p>
        </Section>

        <Section title="7. AI-Generated Content">
          <p>
            LiveBetter uses artificial intelligence to generate insights, predictions, coaching
            responses, and recommendations. AI-generated content may not always be accurate, complete,
            or appropriate for your specific situation. You acknowledge that:
          </p>
          <ul style={ulStyle}>
            <li>AI outputs are suggestions, not professional advice</li>
            <li>You are responsible for evaluating and acting on AI-generated content at your own discretion</li>
            <li>We do not guarantee the accuracy or reliability of AI-generated content</li>
          </ul>
        </Section>

        <Section title="8. Subscriptions and Payments">
          <h3 style={h3Style}>8.1 Free and Paid Tiers</h3>
          <p>
            LiveBetter offers free and paid subscription tiers. Paid features are clearly marked within
            the app.
          </p>

          <h3 style={h3Style}>8.2 Billing</h3>
          <p>
            Paid subscriptions are billed monthly through Stripe. By subscribing, you authorize us to
            charge your payment method on a recurring basis until you cancel.
          </p>

          <h3 style={h3Style}>8.3 Cancellation</h3>
          <p>
            You may cancel your subscription at any time. Cancellation takes effect at the end of the
            current billing period. No refunds are provided for partial billing periods.
          </p>

          <h3 style={h3Style}>8.4 Price Changes</h3>
          <p>
            We may change subscription prices with at least 30 days' notice. Continued use after a
            price change constitutes acceptance of the new price.
          </p>
        </Section>

        <Section title="9. Social Features">
          <p>
            LiveBetter includes optional social features (circles, partnerships, nudges). When using
            these features:
          </p>
          <ul style={ulStyle}>
            <li>You consent to sharing limited wellness data with group members</li>
            <li>You agree to interact respectfully with other users</li>
            <li>You may leave any group or partnership at any time</li>
            <li>We may remove users who violate these Terms from social features</li>
          </ul>
        </Section>

        <Section title="10. Intellectual Property">
          <p>
            The Service, including its design, code, content, and branding, is owned by LiveBetter and
            protected by intellectual property laws. You may not copy, modify, distribute, or create
            derivative works from the Service without our written permission.
          </p>
          <p>
            You retain ownership of the data you submit to LiveBetter. By using the Service, you
            grant us a limited license to use your data solely to provide and improve the Service as
            described in our Privacy Policy.
          </p>
        </Section>

        <Section title="11. Account Termination">
          <ul style={ulStyle}>
            <li>You may delete your account at any time from the app settings.</li>
            <li>
              We may suspend or terminate your account if you violate these Terms, with or without
              notice.
            </li>
            <li>
              Upon account deletion, all your personal data is permanently removed from our systems.
            </li>
          </ul>
        </Section>

        <Section title="12. Limitation of Liability">
          <p>
            To the maximum extent permitted by law, LiveBetter and its affiliates, officers, and
            employees shall not be liable for any indirect, incidental, special, consequential, or
            punitive damages, including but not limited to loss of data, health outcomes, or profits,
            arising from your use of the Service.
          </p>
          <p>
            Our total liability for any claim arising from the Service shall not exceed the amount you
            paid us in the 12 months preceding the claim, or $100, whichever is greater.
          </p>
        </Section>

        <Section title="13. Disclaimer of Warranties">
          <p>
            The Service is provided "as is" and "as available" without warranties of any kind, whether
            express or implied, including but not limited to implied warranties of merchantability,
            fitness for a particular purpose, and non-infringement.
          </p>
        </Section>

        <Section title="14. Changes to These Terms">
          <p>
            We may update these Terms from time to time. We will notify you of material changes via
            email or in-app notification at least 30 days before they take effect. Continued use of the
            Service after changes become effective constitutes acceptance.
          </p>
        </Section>

        <Section title="15. Governing Law">
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the
            jurisdiction in which LiveBetter operates, without regard to conflict of law principles.
          </p>
        </Section>

        <Section title="16. Contact Us">
          <p>For questions about these Terms, contact us at:</p>
          <ul style={{ ...ulStyle, listStyle: "none", paddingLeft: 0 }}>
            <li>Email: <a href="mailto:support@livebetter.one" style={linkStyle}>support@livebetter.one</a></li>
          </ul>
        </Section>

        <Footer />
      </div>
    </div>
  );
}

const h3Style = { fontSize: 16, fontWeight: 600, marginTop: 20, marginBottom: 8 };
const ulStyle = { paddingLeft: 24, lineHeight: 1.8 };
const linkStyle = { color: "#0B9FBD", textDecoration: "underline" };

function Section({ title, children }) {
  return (
    <section style={{ marginBottom: 36 }}>
      <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 12, fontFamily: "Outfit, sans-serif" }}>{title}</h2>
      <div style={{ lineHeight: 1.7, color: "#333" }}>{children}</div>
    </section>
  );
}

function Footer() {
  return (
    <footer style={{ marginTop: 64, paddingTop: 24, borderTop: "1px solid #E2E8F0", display: "flex", gap: 24, fontSize: 14, color: "#64748B" }}>
      <Link to="/privacy" style={{ color: "#64748B", textDecoration: "none" }}>Privacy Policy</Link>
      <Link to="/terms" style={{ color: "#64748B", textDecoration: "none" }}>Terms of Service</Link>
      <span style={{ marginLeft: "auto" }}>LiveBetter {new Date().getFullYear()}</span>
    </footer>
  );
}
